import {
  MenuItem,
  FormControl,
  ListItemText,
  Checkbox,
  Button,
  Typography,
  Grow,
  Paper,
  MenuList,
  Popper,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";

const HotelIdValueChooser = ({
  managers,
  selectedManagers,
  onManagersChange,
  width,
  isSingle,
  label,
}) => {
  const buttonRef = useRef(undefined);
  const popperRef = useRef(undefined);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        popperRef.current &&
        !popperRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsVisible(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <FormControl>
      <Button
        ref={buttonRef}
        sx={{
          width: width,
          border: "1px solid #262626",
          outline: isVisible ? "1px solid #262626" : "1px solid transparent",
          fontSize: "16px",
          height: "55px",
        }}
        onClick={() => {
          setIsVisible((p) => !p);
        }}
      >
        <Typography
          noWrap
          sx={{
            padding: "9px 12px",
            textOverflow: "ellipsis",
            textTransform: "none",
            wordBreak: "break-all",
            maxLines: 1,
          }}
          variant="h6"
          fontSize={"15px"}
          color="primary.main"
        >
          {label ? label : selectedManagers.map(it => it.name).join(", ")}
        </Typography>
      </Button>

      <Popper
        anchorEl={buttonRef.current}
        role={undefined}
        placement="bottom"
        open={isVisible && Boolean(buttonRef.current)}
        disablePortal={true}
        transition
        ref={popperRef}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: "center top" }}>
            <Paper
              elevation={10}
              sx={{
                marginTop: "3px",
                maxHeight: "450px",
                overflow: "scroll",
              }}
            >
              <MenuList>
                {!isSingle && (
                  <MenuItem
                    onClick={() => {
                      if (selectedManagers.length === managers.length) {
                        onManagersChange([]);
                      } else {
                        onManagersChange([...managers]);
                      }
                    }}
                    key="All"
                  >
                    <Checkbox
                      checked={selectedManagers.length === managers.length}
                    />
                    <ListItemText primary="All" />
                  </MenuItem>
                )}

                {[...managers].map((manager) => {
                  return (
                    <MenuItem
                      onClick={() => {
                        if (isSingle) {
                          onManagersChange([manager]);
                        } else {
                          if (selectedManagers.includes(manager)) {
                            let sHot = [...selectedManagers];
                            sHot.splice(sHot.indexOf(manager), 1);
                            onManagersChange(sHot);
                          } else {
                            onManagersChange([...selectedManagers, manager]);
                          }
                        }
                      }}
                      key={manager.id}
                      value={manager.id}
                    >
                      <Checkbox checked={selectedManagers.indexOf(manager) > -1} />
                      <ListItemText primary={`${manager.name}(${manager.email})`} />
                    </MenuItem>
                  );
                })}
              </MenuList>
            </Paper>
          </Grow>
        )}
      </Popper>
    </FormControl>
  );
};

export default HotelIdValueChooser;
